export type RuntimeEnv = Record<string, string | undefined>;

export const RuntimeEnvKey = {
  SECURITY_URL: 'DEC_SEC_URL',
  APPLICATION_URL: 'DEC_API_URL',
  WEB_URL: 'DEC_WEB_URL',
  SESSION_IDLE_TIMEOUT_SECONDS: 'SESSION_IDLE_TIMEOUT_SECONDS'
} as const;

export type RuntimeEnvKey = (typeof RuntimeEnvKey)[keyof typeof RuntimeEnvKey];
